
import {NavLink, Redirect, useHistory} from "react-router-dom";
import {useState, useEffect} from 'react'
//axios
import axios from 'axios'
//import {useForm} from 'react-hook-form';

//formik
import {Formik, Form , useFormikContext} from 'formik'
import * as Yup from 'yup'

//loader
import Loader from 'react-loader-spinner'

import {TextInput} from '../../includes/formLibs/FormLibs'

import Button from '../../includes/button/Button';

import logo from '../../../../images/nv_logo.png';
import imageBus from '../../../../images/image-bus.png';

function ResetPassword(){

    const history = useHistory()
    //err
    const [err, setErr] = useState('')

    const [auth, setAuth] = useState(false)

    useEffect(()=>{
        document.title="Beenonvi | Reinitialiser mot de passe"
        return (()=>{
            document.title=""
        })
    },[]);


    if(sessionStorage.getItem('userData')){
        return (<Redirect to={'/user-admin'} />)
    }


    return(
        <div className="log-reg">
            <div className="log-reg__content">
                <div className="log-reg__head">
                    {/*<NavLink to="/" className="log-reg__logo">
                        <img src={logo} alt="logo_nonvi_voyage"/>
                    </NavLink>
                    <NavLink to="/">
                        <span className="mdi mdi-arrow-left"></span>
                        Retour à l'accueil
                    </NavLink>*/}
                </div>
                <div className="log-reg__body">
                    {/*<div className="log-reg__banner">
                        <div className="log-reg__img">
                            <img src={imageBus} alt="image_bus" />
                        </div>
                    </div>*/}
                        
                    <div className="log-reg__form">
                    <Formik
                        initialValues ={{
                            phone:"",
                            password:"",
                            confirmPassword:""
                        }}

                        validationSchema = {
                            Yup.object({
                                phone: Yup.string().required('Telephone obligatoire'),
                                password: Yup.string().required('Mot de passe obligatoire'),
                                confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], 'Mot de passe non conforme').required('Mot de passe non confirméé')     
                            })
                        }

                        onSubmit = {(values, {setSubmitting, setFieldError}) => {
                            console.log(values)
                            axios.post("https://backoffice.beenonvi.bj/api/v1/reset-password" , 
                            {
                                phone:values.phone,
                                password: values.password
                            },
                            {
                                headers : {
                                    'Accept': "application/json",
                                    'Content-Type': "application/json"
                                }
                            }).then((response) => {
                                const {data} = response
                                if(data.success === false){
                                    setErr(data.message)
                                    setSubmitting(false)
                                } else if(data.success === true){
                                    setErr(data.message)
                                    setSubmitting(false)
                                }
                            }).catch(err => console.log(err))
                            
                        }}
                    >
                        
                        {({isSubmitting, handleChange}) => (
                            <Form className="form">
                                <p 
                                    className="mb-3 mt-0" 
                                    style={{
                                        'padding':`${err == "" ? null : "5px 10px"}`,
                                        'fontSize': "14px"
                                    }}>
                                    {err}
                                </p>
                                <TextInput
                                    label="Téléphone"
                                    type="text"
                                    name="phone"
                                    placeholder="entrer votre numero"
                                    onChange={handleChange}
                                />
                                <TextInput
                                    label="Nouveau mot de passe"
                                    type="password"
                                    name="password"
                                    placeholder="entrer nouveau mot de passe"
                                    onChange={handleChange}
                                />
                                <TextInput
                                    label="Confirmer mot de passe"
                                    type="password"
                                    name="confirmPassword"
                                    placeholder="confirmer mot de passe"
                                    onChange={handleChange}
                                />
                                <div className={`form__item ${isSubmitting && 'text-center'}`}>
                                    {!isSubmitting &&(
                                        <Button type="submit" text="Réinitialiser mot de passe"/>
                                    )}
                                    {isSubmitting &&(
                                        <Loader
                                            type="ThreeDots"
                                            color="orange"
                                            height="40px"
                                            width="60"
                                        />
                                    )}
                                </div>
                            </Form>

                        )}  
                        
                    </Formik>
                        <p>
                            <NavLink to="/register" className="link">
                                <span className="mdi mdi-chevron-double-left"></span>
                                Créer un compte
                                <span className="mdi mdi-chevron-double-right"></span>
                            </NavLink>
                            <NavLink to="/login" className="link">
                                <span className="mdi mdi-chevron-double-left"></span>
                                Se connecter
                                <span className="mdi mdi-chevron-double-right"></span>
                            </NavLink>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )


}
export default ResetPassword;